import { useState, useEffect } from 'react'
import _ from 'lodash'
import isEmail from 'validator/lib/isEmail'
import isUrl from 'validator/lib/isURL'
import isPhone from 'validate-phone-number-node-js'

import {Typography} from '@mui/material'

import CustomTextField from '../common/wizard-custom-textfield'

const RailRetailer = ({setPrevButtonState, setNextButtonState, template, setTemplate, classData, setClassData }) => {

  const [retailer, setRetailer] = useState("") 
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [website, setWebsite] = useState("") 

  const [retailerValid, setRetailerValid] = useState(true)
  const [phoneValid, setPhoneValid] = useState(true)
  const [emailValid, setEmailValid] = useState(true)
  const [websiteValid, setWebsiteValid] = useState(true) 

  const setClassTextFieldValue = (field, value) => {
    let c = _.cloneDeep(classData)
    const index = _.findKey(c.textModulesData, function (i) { return i.wizard === field })
    c.textModulesData[index].body = value
    setClassData(c)
  }

  const setClassLinksFieldValue = (field, value) => {
    let c = _.cloneDeep(classData)
    const index = _.findKey(c.linksModuleData.uris, function (i) { return i.wizard === field })
    c.linksModuleData.uris[index].uri = value
    setClassData(c)
  }

  const setTemplateValue = (type, field, value) => {
    let t = _.cloneDeep(template)
    const index = _.findKey(t.backFields, function (i) { return i.wizard === field })
    t[type][index].value = value
    setTemplate(t)
  }

  const getTemplateValue = (type, field) => {
    const index = _.findKey(template.backFields, function (i) { return i.wizard === field })
    return template[type][index].value
  }

  useEffect(() => {
    if (template.backFields) {
      setRetailer(getTemplateValue("backFields", "retailer"))
      setPhone(getTemplateValue("backFields", "phone"))
      setEmail(getTemplateValue("backFields", "email"))
      setWebsite(getTemplateValue("backFields", "website"))
    }
  }, [template])

  useEffect(() => {
    setPrevButtonState("enabled")
    setNextButtonState("disabled")
  }, [])

  useEffect(() => {
    if(retailerValid && phoneValid && emailValid && websiteValid && retailer.length > 2 && phone.length && email.length && website.length ){
      setNextButtonState("enabled")
    } else {
      setNextButtonState("disabled")
    }
  }, [retailer, phone, email, website,retailerValid, phoneValid, emailValid, websiteValid])

  const setRetailerValue = value => {
    setRetailer(value)
    setTemplateValue("backFields", "retailer", value)
    setClassTextFieldValue("retailer", value)
  }

  const setPhoneValue = value => {
    setPhone(value)
    setTemplateValue("backFields", "phone", value)
    setClassLinksFieldValue("phone", value)
  }

  const setEmailValue = value => {
    setEmail(value)
    setTemplateValue("backFields", "email", value)
    setClassLinksFieldValue("email", value)
  }

  const setWebsiteValue = value => {
    setWebsite(value)
    setTemplateValue("backFields", "website", value)
    setClassLinksFieldValue("website", value)
  }

  const validateRetailer = () => {
    setRetailerValid(retailer.length > 1)
  }

  const validatePhone = () => {
    const status = isPhone.validate(phone)
    setPhoneValid(status)
  }

  const validateEmail = () => {
    const status = isEmail(email)
    setEmailValid(status)
  }

  const validateWebsite = () => {
    const status = isUrl(website,{require_protocol:true,require_valid_protocol:true,protcols: ['http','https']})
    setWebsiteValid(status)
  }

  return (
    <>
      <Typography variant="h3" sx={{ p: 2 }}>Retailer Information</Typography>

      <CustomTextField label="Retailer Name" required={true} value={retailer} onChange={setRetailerValue} validate={validateRetailer} valid={retailerValid} helperText=""/>
      <CustomTextField label="Retailer Phone" required={true} value={phone} onChange={setPhoneValue} validate={validatePhone} valid={phoneValid} helperText="Do not include tel: (it will be added automatically when passes are generated)"/>
      <CustomTextField label="Retailer Email" required={true} value={email} onChange={setEmailValue} validate={validateEmail} valid={emailValid} helperText="Do not include mailto: (it will be added automatically when passes are generated)"/>
      <CustomTextField label="Retailer Website" required={true} value={website} onChange={setWebsiteValue} validate={validateWebsite} valid={websiteValid} helperText="You must include http:// or https:// as appropriate"/>
    </>
  )
}

export default RailRetailer

